module.exports = __webpack_public_path__ + "img/vertical_6_5_7005.5612b744.png";